<form [formGroup]="batchRunForm" (submit)="onSubmit()">
    <h4 mat-dialog-title>Subir versão de {{ data.configurations.length }} app(s) em paralelo</h4>
    <mat-dialog-content>

        <p class="text-muted small mb-2">
            O Version Code de cada app será incrementado automaticamente a partir da última versão salva.
        </p>

        <ul class="selected-apps mb-3">
            <li *ngFor="let config of data.configurations">{{ config.name }}</li>
        </ul>

        <div *ngIf="anyHasIos" class="form-check mb-2 d-flex align-items-center">
            <input formControlName="executeIos" class="me-1 form-check-input" type="checkbox" id="batchExecuteIos">
            <label class="form-check-label" for="batchExecuteIos">Executar Ios</label>
        </div>

        <div *ngIf="anyHasAndroid" class="form-check mb-2 d-flex align-items-center">
            <input formControlName="executeAndroid" class="form-check-input me-1" type="checkbox" id="batchExecuteAndroid">
            <label class="form-check-label" for="batchExecuteAndroid">Executar Android</label>
        </div>

        <div class="mb-2" *ngIf="executeIos">
            <label>Ios</label>
            <select formControlName="iosTrack" class="form-select">
                <option *ngFor="let track of iosTracks">{{ track }}</option>
            </select>
        </div>

        <div class="mb-2" *ngIf="executeAndroid">
            <label>Android</label>
            <select formControlName="androidTrack" class="form-select">
                <option *ngFor="let track of androidTracks">{{ track }}</option>
            </select>
        </div>

        <div class="mb-2">
            <label class="form-label" for="batch-version-name">Version Name</label>
            <input formControlName="versionName" class="form-control" id="batch-version-name" type="text" placeholder="Manter o de cada app">
            <small class="text-muted">Se preenchido, será aplicado a todos os apps selecionados. Em branco, cada app mantém o seu.</small>
        </div>

        <div class="form-outline">
            <label class="form-label" for="batch-release-notes">Release Notes</label>
            <textarea style="resize: none;" formControlName="releaseNotes" class="form-control" id="batch-release-notes" rows="4"></textarea>
        </div>

        <div *ngIf="batchRunForm.hasError('notOsSelected') && batchRunForm.touched" class="text-danger small mt-2">
            Selecione ao menos uma plataforma (Ios ou Android).
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="d-flex justify-content-center gap-2">
            <button type="submit" class="btn btn-primary">Confirmar</button>
            <button type="button" (click)="close()" class="btn btn-danger">Cancelar</button>
        </div>
    </mat-dialog-actions>
</form>
